import webClient from "../config/api.config";
import { InvoiceType } from "../types/invoice.definition";

export function getAllInvoices(
  page = 0,
  size = 10,
  status?: string,
  type?: InvoiceType
) {
  return webClient.request({
    method: "get",
    url: "/invoices",
    params: {
      page,
      size,
      ...(status ? { status } : {}),
      ...(type ? { type } : {}),
    },
  });
}

export function getInvoicesDue(
  year: number,
  month: number,
  page = 0,
  size = 10,
  type?: InvoiceType
) {
  return webClient.request({
    method: "get",
    url: "/invoices/due",
    params: { year, month, page, size, ...(type ? { type } : {}) },
  });
}

export function getInvoiceStats(
  year: number,
  month: number,
  type?: InvoiceType
) {
  return webClient.request({
    method: "get",
    url: "/invoices/stats",
    params: { year, month, ...(type ? { type } : {}) },
  });
}

/** MED-1471: the single outstanding invoice of a facility; 404 when it owes nothing. */
export function getPendingInvoiceForFacility(facilityId: number) {
  return webClient.request({
    method: "get",
    url: `healthcare-facilities/${facilityId}/invoices/pending`,
  });
}

/** MED-1471: really send the invoice by e-mail; 400 when there is no recipient on file. */
export function sendInvoice(invoiceId: number) {
  return webClient.request({
    method: "put",
    url: `invoices/${invoiceId}/send`,
  });
}
